import React from 'react';
import TeacherPayrollReport from '../report/TeacherSettlementsReport';

export default function TeacherPortalSettlements() {
  return <TeacherPayrollReport personal />;
}
